import { validateOfferCodeAction } from 'containers/App/actions';

function asyncValidate(values, dispatch, props, fieldName) {
  if (fieldName !== undefined) {
    if (values.get('premium') !== null && values.get('currency') !== 'Select') {
      if (values.get('offerCode') !== '') {
        return new Promise((resolve, reject) => {
          dispatch(
            validateOfferCodeAction({
              offerCode: values.get('offerCode'),
              productCode: props.product.PTVCode,
              productVersion: props.product.PTVVersion,
              currency: values.get('currency'),
              premium: values.get('premium'),
              premiumType: 'SinglePremium',
              resolve,
              reject,
            }),
          );
        });
      }
    }

    return new Promise(resolve => {
      dispatch(
        validateOfferCodeAction({
          offerCode: '',
          resolve,
        }),
      );
    });
  }

  if (props?.offerCodeData?.errorMessage) {
    return new Promise((resolve, reject) => {
      reject({
        offerCode: props?.offerCodeData?.errorMessage,
      });
    });
  } else {
    return new Promise(resolve => {
      resolve();
    });
  }
}

export default asyncValidate;
